import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'fal-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss']
})
export class ModalComponent {
  @Input()
  public emergencyHeader = 'Emergency';

  @Input()
  public emergencyNotifications = 'This is an emergency';

  @Output()
  public closeModal = new EventEmitter<boolean>();

  public close(): void {
    this.closeModal.emit(true);
  }
}
